
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import TasksTypesListView from "./tasks_types-list.html";
import TasksTypesEditView from "./tasks_types-edit.html";

angular.module("tasks_types", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('tasks_types', {
                url: "/tasks_types",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('tasks_types.list', {
                url: "/list",
                controller: "TasksTypesListCtrl",
                template: TasksTypesListView,
                requiredPermission: ["TASKS_TYPES_READ"]
            })             
            .state('tasks_types.edit', {
                url: "/edit/:id",
                controller: "TasksTypesEditCtrl",
                template: TasksTypesEditView,
                requiredPermission: ["TASKS_TYPES_READ"]
            })
    }])
;